import { useEffect, useMemo, useState } from "react";
import { type CountryDays, type ResidencyFlag, taxApi } from "../../lib/api/tax.js";
import "./Tax.css";

const THIS_YEAR = Number(new Date().toISOString().slice(0, 4));

export function Tax() {
  const [year, setYear] = useState(THIS_YEAR);
  const [days, setDays] = useState<CountryDays[]>([]);
  const [flags, setFlags] = useState<ResidencyFlag[]>([]);

  useEffect(() => {
    taxApi.days(year).then((r) => setDays(r.success && r.data ? r.data.days : []));
    taxApi.residency(year).then((r) => setFlags(r.success && r.data ? r.data.flags : []));
  }, [year]);

  const max = useMemo(() => Math.max(183, ...days.map((d) => d.days)), [days]);
  const years = [THIS_YEAR, THIS_YEAR - 1, THIS_YEAR - 2];

  return (
    <section className="tax">
      <div className="tax__head">
        <h1 className="tax__h1">Days by country</h1>
        <select aria-label="year" value={year} onChange={(e) => setYear(Number(e.target.value))}>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {flags.length > 0 && (
        <div className="tax__flags">
          {flags.map((f) => (
            <p key={f.country_code} className={`tax__flag tax__flag--${f.status}`}>
              {f.status === "over" ? "⚠️" : "⏳"} {f.country}: {f.days} days
              {f.status === "over"
                ? ` — past the ${f.threshold}-day mark`
                : ` — nearing ${f.threshold}`}
            </p>
          ))}
        </div>
      )}

      <ul className="tax__bars">
        {days.map((d) => (
          <li key={d.country_code} className="tax__bar-row">
            <span className="tax__country">{d.country}</span>
            <span className="tax__track">
              <span className="tax__bar" style={{ width: `${(d.days / max) * 100}%` }} />
            </span>
            <span className="tax__days">{d.days}</span>
          </li>
        ))}
        {days.length === 0 && <p className="tax__muted">No travel recorded for {year}.</p>}
      </ul>

      <p className="tax__disclaimer">Informational only — not tax advice.</p>
    </section>
  );
}
